// extracted by mini-css-extract-plugin
export var topSearches = "styles-module--top-searches--d9cc1";
export var topSearches__container = "styles-module--top-searches__container--b7a59";
export var topSearches__result = "styles-module--top-searches__result--5a806";
export var topSearches__resultTag = "styles-module--top-searches__result-tag--752bd";
export var topSearches__title = "styles-module--top-searches__title--b63d1";